// Choice-line label with the quantity after the name ("Add Pickles × 2"),
// matching the kiosk's ordering rather than the old "2 × Add Pickles" prefix.
export const nameWithQuantityToString = (name: string, quantity?: number): string =>
  `${name}${(quantity ?? 0) > 1 ? ` × ${quantity}` : ''}`;
